import React from 'react';
import ReactDOM from 'react-dom'
import '../../App.css';
import '../../bootstrap.css';
import Autosuggest from 'react-autosuggest';
import {
  getPercentOf, NUTRITION_DATA, dataEntryContentAreEqual, getFoodQualityMatches,
  getNumberOfUnitServings, FOOD_TAGS, fromExternalSource
} from '../../helpers/Util';
import * as Elasticsearch from '../../helpers/esFoodParser'; // Legacy
import * as esUserFoodHistory from '../../helpers/esUserFoodHistory';
import * as Database from '../../helpers/Database';
import * as FatSecret from '../../helpers/FatSecret';
import { AutosuggestTheme, AutosuggestThemeRed } from '../../helpers/Themes';
import FoodTagsForm from './FoodTagsForm';
import FoodConversionTool from './FoodConversionTool';
import * as Analytics from '../../helpers/Analytics';

let _ = require('lodash');

function getServingName(servingPartialDoc) {
  return servingPartialDoc.unit ? servingPartialDoc.unit : servingPartialDoc.name; // FatSecret uses 'name' still
}

const SERVINGS = {
  "C": "cup",
  "G": "gram",
  "L": "liter",
  "bite": "bite",
  "bowl": "bowl",
  "c": "cup",
  "can": "can",
  "clove": "clove",
  "cob": "cob",
  "cm": "centimeter",
  "cup": "cup",
  "cups": "cup",
  "dash": "dash",
  "default": "default",
  "ear": "ear",
  "finger": "finger",
  "finger tip": "fingertip",
  "fingertip": "fingertip",
  "fist": "fist",
  "fist size": "fist",
  "fist sized": "fist",
  "fist-size": "fist",
  "fist-sized": "fist",
  "fistful": "fist",
  "g": "gram",
  "gal": "gallon",
  "gallon": "gallon",
  "gm": "gram",
  "gram": "gram",
  "handful": "handful",
  "in": "inch",
  "inch": "inch",
  "kilogram": "kilogram",
  "km": "kilogram",
  "l": "liter",
  "lb": "pound",
  "liter": "liter",
  "litre": "liter",
  "milliliter": "milliliter",
  "ml": "milliliter",
  "mug": "mug",
  "ounce": "ounce",
  "oz": "ounce",
  "pack": "pack",
  "package": "package",
  "palm": "palm",
  "palm size": "palm",
  "palm sized": "palm",
  "palm-size": "palm",
  "palm-sized": "palm",
  "piece": "piece",
  "pinch": "pinch",
  "pint": "pint",
  "portion": "portion",
  "pound": "pound",
  "pt": "pint",
  "qt": "quart",
  "quart": "quart",
  "recipe": "recipe",
  "sip": "sip",
  "slice": "slice",
  "slices": "slices",
  "t": "tablespoon",
  "tablespoon": "tablespoon",
  "tb": "tablespoon",
  "tbl": "tablespoon",
  "tblspn": "tablespoon",
  "tbs": "tablespoon",
  "tbsp": "tablespoon",
  "teaspoon": "teaspoon",
  "thumb": "thumb",
  "tsp": "teaspoon"
};

const MAX_PREVIEW_SERVINGS_CHARS = 200;
const NUTRITION_DATA_NAMES = {
  calories: 'calories',
  fat: 'fat',
  carbs: 'carbs',
  protein: 'protein',
  fiber: 'fiber',
  netCarbs: 'netCarbs',
  sugar: 'sugar'
};

const SECTION_TYPE = { // NOTE: Keep this up to date with vivabot.
  ElasticsearchUserHistory: Elasticsearch.HIT_TYPE.UserHistory,
  External: 'FatSecret',
  ExternalRecipes: 'FatSecret Recipes'
};
let totalSections = Object.keys(SECTION_TYPE).length;
let emptySearchHitsCache = [];
for (let i = 0; i < totalSections; i++) {
  emptySearchHitsCache.push({});
}

let servingUnits = {};
Database.doOnReadingFirebaseEntry('servingUnits', (snapshot) => {
  servingUnits = snapshot.val();
});

const DEFAULT_SERVING_PLACEHOLDER = `e.g., 1 cup, 0.5 oz, 2 pieces`;
const DEFAULT_FOOD_PLACEHOLDER = 'Start typing to search food';

function ignoreCalorieBufferForTag(tags) {
  if (_.isEmpty(tags)) {
    return false;
  }

  for (let i in tags) {
    let tag = tags[i];
    if (!(tag === FOOD_TAGS.Fruits || tag === FOOD_TAGS.NutsSeeds || tag === FOOD_TAGS.OilsFats || tag === FOOD_TAGS.Spices)) {
      return false;
    }
  }
  return true;
}

function getBestMatchForUnknownRestaurant(contenders) {
  let filteredContenders = _.remove(contenders, c => c.calories !== undefined);
  let sortedContenders = _.sortBy(filteredContenders, ['calories']);
  return sortedContenders[sortedContenders.length - 1];
}

function getNumber(text) {
  return text ? _.toNumber(text) : 0;
}

export default class FoodLoggingForm2 extends React.Component {
  constructor(props) {
    super(props);
    //this.foodAutosuggest = null;
    this.prevDataEntryWritePath = [];
    this.clearFoodHitsCache();
    this.foodInputTimer = null;
    this.foodTagsErrorMsg = "";
    this.parsedFood = {};
    this.mappedFood = {};
    this.originalText = '';
    this.containsBrandName = false;
    this.usersCannedFoodHabits = this.props.usersCannedFoodHabits;
    this.usersCannedFoodHabitsTagsIndex = this.props.usersCannedFoodHabitsTagsIndex;
    this.dailyHabitsMap = this.props.dailyHabitsMap;
    this.weeklyHabitsMap = this.props.weeklyHabitsMap;
    this.category = null;
    this.foodInputChangedSinceLastSelection = false; // DEP changed food name since last dropdown selection
    this.caloriesChangedSinceLastSelection = false;

    this.state = {
      errorMessage: "",
      successMessage: "",
      selectedFoodId: "",
      selectedFoodName: "",
      brandName: '',
      selectedFoodNutritionData: {},
      selectedServingName: null,
      selectedServingIndex: -1,
      servingNumber: Elasticsearch.DEFAULT_SERVING_NUMBER, // must be a number > 0, Should be the same as servingNumberInputText unless the latter is empty
      servingNumberInputText: '', // What's in the textbox, can be empty string
      searchHits: [],
      selectedHitServings: [],
      tags: [],
      servingDDPlaceholder: DEFAULT_SERVING_PLACEHOLDER,
      foodDDPlaceholder: DEFAULT_FOOD_PLACEHOLDER,
      numberOfUnitServings: 1,
      targetDate: this.props.targetDate,
      promptOverwriteFood: false,
      ingredients: [],
      urls: [],
      totalServings: null,
      addCalorieBuffer: false,
    }

    // For ReactAutosuggest food control
    this.selectedFoodNameTextChangeAsync = this.selectedFoodNameTextChangeAsync.bind(this);
    this.onFoodSuggestionsClear = this.onFoodSuggestionsClear.bind(this);
    this.renderFoodSuggestion = this.renderFoodSuggestion.bind(this);
    this.foodInputChange = this.foodInputChange.bind(this);

    // For ReactAutosuggest serving control
    this.selectedServingChange = this.selectedServingChange.bind(this);
    this.onServingSuggestionsClear = this.onServingSuggestionsClear.bind(this);
    this.renderServingSuggestion = this.renderServingSuggestion.bind(this);
    this.servingInputChange = this.servingInputChange.bind(this);

    this.selectedFoodNutritionDataChange = this.selectedFoodNutritionDataChange.bind(this);
    this.uploadFoodsSubmitAsync = this.uploadFoodsSubmitAsync.bind(this);
    this.servingNumberChange = this.servingNumberChange.bind(this);
    this.checkboxChanged = this.checkboxChanged.bind(this);
    this.deleteFood = this.deleteFood.bind(this);
    this.deleteServing = this.deleteServing.bind(this);
    this.renderSectionTitle = this.renderSectionTitle.bind(this);
    this.getSectionSuggestions = this.getSectionSuggestions.bind(this);
    this.calorieBufferChange = this.calorieBufferChange.bind(this);
    this.storeInputReference = this.storeInputReference.bind(this);

    Database.doOnGetBufferObj(this.props.userId, 'calories', (bufferObj) => {
      // FUTURE: Consolidate every update of calorieBufferPercent awith calorieBufferValue into 1 function since they're always updated together
      let newCalorieBufferValue = _.has(this.state, 'nutritionData.calories') ?
        getPercentOf(this.state.calorieBufferPercent, this.state.nutritionData.calories) : 0;
      this.setState({
        // Do not set addCalorieBuffer: true here. Otherwise it will cause race condition with populateFoodLoggingForm. So let populateFoodLoggingForm
        // but the one in charge of this.
        calorieBufferPercent: bufferObj.value ? bufferObj.value : Database.DEFAULT_BUFFER_VAL,
        calorieBufferValue: newCalorieBufferValue
      });
    });
  }

  async componentDidMount() {
    await this.applyDataEntryObjAsync(null, this.props.dataEntryObj);
  }

  componentWillUnmount() {
    for (let path in this.prevDataEntryWritePath) {
      Database.clearValueChangeCallback(path);
    }
  }

  async componentWillReceiveProps(nextProps) {
    await this.applyDataEntryObjAsync(this.props.dataEntryObj, nextProps.dataEntryObj);

    if (!_.isEqual(nextProps.usersCannedFoodHabits, this.usersCannedFoodHabits)) {
      this.usersCannedFoodHabits = nextProps.usersCannedFoodHabits;
    }

    if (!_.isEqual(nextProps.usersCannedFoodHabitsTagsIndex, this.usersCannedFoodHabitsTagsIndex)) {
      this.usersCannedFoodHabitsTagsIndex = nextProps.usersCannedFoodHabitsTagsIndex;
    }

    if (!_.isEqual(nextProps.dailyHabitsMap, this.dailyHabitsMap)) {
      this.dailyHabitsMap = nextProps.dailyHabitsMap;
    }

    if (!_.isEqual(nextProps.weeklyHabitsMap, this.weeklyHabitsMap)) {
      this.weeklyHabitsMap = nextProps.weeklyHabitsMap;
    }
  }

  _getConsolidatedServingText = (servingNumber, servingName, foodName) => {
    let isValidNonDefaultServingNumber = Elasticsearch.isValidServingNumber(servingNumber) && servingNumber != Elasticsearch.DEFAULT_SERVING_NUMBER;

    let { servingUnitNumber, servingUnit } = Elasticsearch.parseServingDescription(servingName);
    if (!servingUnitNumber) {
      servingUnitNumber = Elasticsearch.DEFAULT_SERVING_NUMBER;
    }
    let consolidatedServingNumber = servingUnitNumber;

    if (isValidNonDefaultServingNumber) {
      consolidatedServingNumber = _.round(servingNumber * servingUnitNumber, 2);
    }

    if (!SERVINGS[servingUnit.toLowerCase()] && // This first check is to prevent detecting "100 g yogurt" --> "1 yogurt" (because there's 'g' in 'yogurt')
      (_.isEmpty(servingName) || foodName.indexOf(servingUnit) >= 0 || servingUnit.indexOf(foodName) >= 0)
    ) {
      return `${consolidatedServingNumber}`;
    } else {
      return `${consolidatedServingNumber} ${servingUnit}`;
    }
  }

  dateChange = (e) => {
    this.setState({ targetDate: e.target.value });
  }

  setParsedFood(servingName, servingNumber, name) {
    this.parsedFood = { servingName, servingNumber, name };
  }

  getInferredContextAsync = async (originalText) => {
    let inferredContext = {
      fromRestaurant: false, fromRecipe: false, fromYesterday: false
    };
    let textLower = originalText.toLowerCase();
    // hasRestaurantIndicators if it's this form '<some text>:' or says 'restaurant'
    if (/^(.*?)\:/i.test(textLower) || textLower.includes('restaurant')) {
      inferredContext.fromRestaurant = true;
    }

    // hasRecipeIndicators if the words 'recipe' or 'recipes' show up
    if (textLower.includes('recipe')) {
      inferredContext.fromRecipe = true;
    }

    // this text may be for foods from yesterday
    if (textLower.includes('yesterday') || textLower.includes('last night') || textLower.includes('day before') ||
      textLower.includes('night before') || textLower.includes('previous day') || textLower.includes('previous night')
    ) {
      if (!(/(same )(.*)(as )/.test(textLower) || /(same )(.*)(from )/.test(textLower))) {
        inferredContext.fromYesterday = true;
      }
    }
    return inferredContext;
  }

  async applyDataEntryObjAsync(oldDataEntryObj, newDataEntryObj) {
    if (!dataEntryContentAreEqual(newDataEntryObj, oldDataEntryObj)) {
      this.submittedForThisDataEntryObj = false;
      if (!newDataEntryObj) {
        this.clearFoodForm();
      } else {
        if (newDataEntryObj.isMedia) {
          this.setState({ autofilled: true }); // Don't populate the form but set this to true anyway so it highlights
        } else {
          let hitId = newDataEntryObj.topHitId;
          if (newDataEntryObj.parsed) {
            this.setParsedFood(newDataEntryObj.parsed.servingUnit, newDataEntryObj.parsed.servingNumber, newDataEntryObj.parsed.name);
          }
          this.originalText = newDataEntryObj.originalText;

          if (!hitId || fromExternalSource(hitId)) { // vHIST TODO: No way to get auto-populate FS suggestion right now without lots of refactoring, so just do client-side search. https://app.asana.com/0/286104021310008/1203018768504722
            await this.selectedFoodNameTextChangeAsync({
              value: newDataEntryObj.name,
              reason: 'input-changed'
            }) // Force a new search for the top hit name that api server found.
            let foodAutosuggestDOMNode = ReactDOM.findDOMNode(this.input);
            if (foodAutosuggestDOMNode) {
              foodAutosuggestDOMNode.focus();
            }
            return;
          }

          let results = await esUserFoodHistory.getFood(hitId);

          if (results.error) {
            this.setState({ errorMessage: `error retrieving elasticsearch hit for autofill with hitId ${hitId} with error ${results.error}` });
            return;
          }
          let hit = results.response;

          // This code below adjusted the top hit if this is inferred to be a recipe. TODO: Come back and figure out if we still need this?
          if (!newDataEntryObj.manualPick) {
            let inferredContext = await this.getInferredContextAsync(newDataEntryObj.originalText)
            // Exclude looking for alt restaurant options if this current top hit match doesn't know what the serving name is. Because it wouldn't be a fair comparison
            // since it won't have any computed calories.
            if (inferredContext.fromRestaurant && !inferredContext.fromRecipe && !_.isEmpty(newDataEntryObj.topServingName)) {
              let brandName = hit._source.brandName ? hit._source.brandName : '';
              let brandNameClipped = brandName.replace(/'s/g, ''); // Handle things like trader joe's - not everyone includes the 's
              let containsBrandNameMatch = !_.isEmpty(this.originalText) && !_.isEmpty(brandName) &&
                this.originalText.toLowerCase().includes(brandNameClipped.toLowerCase());
              if (!containsBrandNameMatch) {
                let newDataEntryVal = getBestMatchForUnknownRestaurant(newDataEntryObj.finalContenders);
                if (hitId !== newDataEntryVal.topHitId && (hitId && !fromExternalSource(hitId))) {
                  let newResults = await esUserFoodHistory.getFood(newDataEntryVal.topHitId);
                  if (!newResults.error) { // Just ignore this if there was an error and fallback to the default top pick
                    hit = newResults.response;
                    hitId = newDataEntryVal.topHitId;
                    newDataEntryObj.topServingName = newDataEntryVal.topServingName
                    newDataEntryObj.topServingNumber = newDataEntryVal.topServingNumber;
                    newDataEntryObj.topHitSection = newDataEntryVal.topHitSection;
                    newDataEntryObj.topScore = newDataEntryVal.topScore;
                  }
                }
              }
            }
          }

          let servingName = newDataEntryObj.topServingName;
          let servingIndex = servingName ? _.findIndex(hit._source.servings, item => getServingName(item) === servingName) : -1;
          this.mappedFood = {
            hit: hit,
            servingName: servingName,
            name: hit._source.name,
            brandName: hit._source.brandName
          };

          this.clearFoodHitsCache();
          this.originalText = newDataEntryObj.originalText;
          this.setState({
            originalText: this.originalText,
            searchHits: this.searchHitsCache
          });

          let section = newDataEntryObj.topHitSection;
          let ddItem = { section: section, hit: hit };
          this.setNewTopAutofillParams(ddItem, servingIndex, newDataEntryObj.topServingNumber);
          this.populateFoodLoggingForm(hit, section, true, newDataEntryObj.hitUserIndex);
          let foodAutosuggestDOMNode = ReactDOM.findDOMNode(this.input);
          if (foodAutosuggestDOMNode) {
            foodAutosuggestDOMNode.focus();
          }

          this.useDataEntryValCache = true;
          if (!_.isEmpty(newDataEntryObj.foodSections)) {
            this.foodSectionsCache = newDataEntryObj.foodSections;
            for (let foodSectionItem of newDataEntryObj.foodSections) {
              this.foodSectionSearchCompleteAsync(foodSectionItem.foodSectionName, foodSectionItem.searchHitsForThisSection);
            }
          }
        }
      }
    }
  }

  clearFoodHitsCache() {
    this.userHistorySearchComplete = false;
    this.searchHitsCache = _.cloneDeep(emptySearchHitsCache);
  }

  // TEST CASES: '2 cups mixed fruit', 'two slices of pizza', '1/2 tbsps peanut butter', 'garlic soup', '.5 cup chicken salad',
  // '0.5 tbsp nutella', '2 fish sticks', '2 sticks of fish', 'nutella, 1 tbsp', 'chicken salad (1 cup)', '1 cup cherries',
  // 'jerk chicken wings', '3 pieces chocolate', '12 oz latte', '1% milk', '2% milk', '1 cup chips', '2 eggs'
  parseSelectedFoodText(foodText) { // ideally of the format '1 oz chicken' (# servingDesc foodName)
    let entities = Elasticsearch.splitByCommonSeparators(foodText);
    let totalEntities = entities.length;
    let quantity = 0;
    let servingDesc = '';
    let foodNameEntites = [];
    let prevWordIsServing = false;
    let prevWordIsNumber = false;
    for (let i = 0; i < totalEntities; i++) {
      let entity = entities[i].toLowerCase();
      entity = _.trim(entity, ' ()[]{},;!:');
      entity = _.trimEnd(entity, '.'); // Only trim periods from the end since they can be decimals
      if (!entity) { // could be empty
        continue;
      }

      let entityAsNumber = Elasticsearch.convertTextToNumber(entity);
      if (!quantity) {
        if (entityAsNumber) {
          quantity = entityAsNumber;
          prevWordIsNumber = true;
          continue;
        } else {
          let { servingUnit, servingUnitNumber } = Elasticsearch.parseServingDescription(entity);
          if (servingUnitNumber) { // This could be in the format #Serving (where there's no space between # and serving)
            quantity = servingUnitNumber;
            servingDesc = servingUnit;
            prevWordIsServing = true;
            continue;
          }
        }
      }

      if ((_.isEmpty(foodNameEntites) || prevWordIsNumber) && !servingDesc && this.isServingUnit(entity)) {
        servingDesc = entity;
        prevWordIsServing = true;
        prevWordIsNumber = false;
        continue;
      } else if (prevWordIsServing && this.isDividerWord(entity)) {
        continue;
      } else {
        foodNameEntites.push(entity);
      }
      prevWordIsServing = false;
      prevWordIsNumber = false;
    }
    let foodName = foodNameEntites.join(' ');
    return { quantity, servingDesc, foodName };
  }

  isDividerWord(word) {
    // Removes text diving serving from food name
    // Doesn't handle things like 'and', 'with', 'without', etc. FUTURE: Figure out how to deal w/these.
    return word === 'of' || word === ',';
  }

  isServingUnit(text) {
    let textLower = text.toLowerCase();
    return servingUnits[textLower] === true;
  }

  selectedFoodNameChange(selectedItem) { // When dropdown selection changes. Return value is passed to foodInputChange.
    if (selectedItem.error) {
      return ''; // Error item is not a real suggestion. Do nothing.
    }

    console.assert(this.state.searchHits);
    if (selectedItem) {
      let selectedHit = selectedItem.hit;
      let foodId = selectedHit._id;
      if (!foodId) {
        this.clearFoodForm();
        return '';
      } else if (this.state.selectedFoodId === foodId) {
        return; // This form should already be populated. Don't populate again because then it will reset any existing serving computations.
      }
      this.populateFoodLoggingForm(selectedHit, selectedItem.section, false /*autoPopulateWithTopResult*/, -1);
      return selectedHit._source.name;
    }
  }

  clearFoodForm() {
    this.clearFoodHitsCache();
    this.setState({
      selectedFoodName: "",
      selectedFoodId: "",
      selectedSection: "",
      selectedFoodNutritionData: {},
      brandName: '',
      searchHits: this.searchHitsCache,
    });
    this.tagsChange([]);
  }

  getTagsForFoodHit(hit) {
    if (hit._source.foodGroups && hit._source.foodGroups.length) {
      return hit._source.foodGroups;
    }

    if (this.state.searchHits) { // If this hit doesn't have tags, try to find an entry with matching food name and grab theirs.
      for (let i = 0; i < this.state.searchHits.length; i++) {
        let hitsForType = this.state.searchHits[i].children;
        if (!_.isEmpty(hitsForType)) {
          for (let j = 0; j < hitsForType.length; j++) {
            let thisHit = hitsForType[j].hit;
            if (thisHit._source.name.toLowerCase() === hit._source.name.toLowerCase() && thisHit._source.foodGroups && thisHit._source.foodGroups.length) {
              return thisHit._source.foodGroups;
            }
          }
        }
      }
    }
    return [];
  }

  getHit(foodId) { // Returns the Elasticsearch hit item. Only applies to entries that already exist in Elasticsearch.
    if (this.state.searchHits) {
      for (let i = 0; i < this.state.searchHits.length; i++) {
        let hitsForType = this.state.searchHits[i].children;
        if (!hitsForType) {
          continue;
        }
        for (let j = 0; j < hitsForType.length; j++) {
          let hit = hitsForType[j].hit;
          if (hit._id === foodId) {
            return hit;
          }
        }
      }
    }

    if (this.topDDItem && this.topDDItem.hit._id === foodId) {
      return this.topDDItem.hit;
    }
    return null;
  }

  renderSectionTitle(section) {
    return (
      <div style={{ backgroundColor: 'lavender' }}><b>{section.type}</b></div>
    );
  }

  getSectionSuggestions(section) {
    if (section.children) {
      return section.children.length ? section.children : [{ error: 'No results :(' }];
    } else if (section.error) {
      return [{ error: section.error }];
    } else {
      return [{ error: 'Loading ...' }];
    }
  }

  // value - the current value of the input
  // reason - string describing why onSuggestionsFetchRequested was called. The possible values are:
  // 'input-changed' - user typed something
  // 'input-focused' - input was focused
  // 'escape-pressed' - user pressed Escape to clear the input (and suggestions are shown for empty input)
  // 'suggestions-revealed' - user pressed Up or Down to reveal suggestions
  // 'suggestion-selected' - user selected a suggestion when alwaysRenderSuggestions={true}
  async selectedFoodNameTextChangeAsync({ value, reason }, query /*Can be undefined*/) { // When text changes in input box.
    // Because it prevents updated queries from viva-bot from updating. E.g., Michelle's "chex mix" bug
    if (value || query) {
      this.deletedHitServings = [];
      if (reason === 'input-changed') {
        this.setState({ // Set all his stuff before we do search, which can take around a second
          selectedFoodName: value,
          selectedFoodId: '',
          selectedSection: '',
          tags: []
        });
        this.foodInputChangedSinceLastSelection = true;
        this._clearIngredientsIfNameOrCaloriesChanged();
      }

      if (!query) {
        query = value;
      }

      if (typeof query !== 'string' || query.length > 200) {
        this.setState({
          errorMessage: `The name of this food is too long or this isn't a string!`
        });
        return;
      }

      if (!_.isEqual(this.searchHitsCache, emptySearchHitsCache) && reason === 'input-focused') {
        // NOTE: Only open the dropdown but don't start a new search unless we don't have any existing search results.\
        this.isDropdownOpenCache = true;
        this.setState({ isDropdownOpen: this.isDropdownOpenCache });
      } else if (reason === 'input-focused' || reason === 'input-changed' || reason === 'suggestions-revealed') {
        this.clearFoodHitsCache();
        this.isDropdownOpenCache = true;
        let newState = { isDropdownOpen: this.isDropdownOpenCache };
        // Comment this out for Asana #571382166857759 - BUG: Clicking on food box makes serving size disappear. Confirm later if we need it.
        // this.updateObjWithServing(newState, [], -1, Elasticsearch.DEFAULT_SERVING_NUMBER, '', 1, true); // Reset serving info
        this.setState(newState);

        ////////// THIS user's history, includes both foods and recipes /////////
        esUserFoodHistory.searchFood(query, this.props.userId, 7, (hits) => {
          if (this.isDropdownOpenCache) { // Dropdown could have already gotten dismissed before results come back. If so, don't complete this action!
            this.foodSectionSearchCompleteAsync(SECTION_TYPE.ElasticsearchUserHistory, hits, null); // no need to await these
          }
        });

        // FatSecret
        clearTimeout(this.foodInputTimer);
        this.foodInputTimer = setTimeout(() => { // FS throttles their API calls, so wait until after user finishes typing to call their API. Assume 500 ms pause means done.
          FatSecret.searchFoods(query, 5, (foods) => {
            let foodHits = null;
            let error = null;
            if (foods && foods.error) {
              error = _.get(foods.error, 'message', foods.error.toString());
            } else if (_.isArray(foods)) {
              foodHits = foods.map(fsFood => FatSecret.convertToElasticsearchHit(fsFood, Elasticsearch.SOURCE_NAME.FS_Food));
            }
            
            foodHits = _.filter(foodHits, v => !_.isEmpty(v));

            if (foodHits && this.isDropdownOpenCache) { // Dropdown could have already gotten dismissed before results come back. If so, don't complete this action!
              this.foodSectionSearchCompleteAsync(SECTION_TYPE.External, foodHits, error);
            }

          });

          FatSecret.searchRecipes(query, 1, (recipes) => { // returns 1 result at a time
            let hits = null;
            let error = null;
            if (recipes && recipes.error) {
              error = _.get(recipes.error, 'message', recipes.error.toString());
            } else if (_.isArray(recipes)) {
              hits = recipes.map(fsRecipe => FatSecret.convertToElasticsearchHit(fsRecipe, Elasticsearch.SOURCE_NAME.FS_Recipe));
            }

            if (hits && this.isDropdownOpenCache) {
              this.foodSectionSearchCompleteAsync(SECTION_TYPE.ExternalRecipes, hits, error);
            }
          });
        }, 500);
      }
    }
  }

  clearAutofillCache() {
    this.topServingIndex = -1;
    this.topDDItem = null;
    this.topServingNumber = 0;
  }

  getIndexOfFoodSection(foodSectionName) {
    if (foodSectionName === SECTION_TYPE.ElasticsearchUserHistory) {
      return 0;
    } else if (foodSectionName === SECTION_TYPE.External) {
      return 1;
    } else if (foodSectionName === SECTION_TYPE.ExternalRecipes) {
      return 2;
    }
    return -1;
  }

  // Called whenever a section has food results (or null/empty if nothing found);
  async foodSectionSearchCompleteAsync(foodSectionName, searchHitsForThisSection /*Can be single hit or array of hits*/, error) {
    searchHitsForThisSection = searchHitsForThisSection ? searchHitsForThisSection : [];
    let sectionIndex = this.getIndexOfFoodSection(foodSectionName);
    let sectionItem = this.searchHitsCache[sectionIndex];
    let existingSectionHits = _.get(sectionItem, 'children', null);
    if (existingSectionHits) {
      if (_.isArray(searchHitsForThisSection)) { // array of hits
        sectionItem.children = _.concat(existingSectionHits, searchHitsForThisSection.map(hit => {
          return { section: foodSectionName, hit: hit }
        }));
      } else { // single hit object
        sectionItem.children.push({ section: foodSectionName, hit: searchHitsForThisSection });
      }
    } else {
      if (_.isArray(searchHitsForThisSection)) { // array of hits
        sectionItem = {
          type: foodSectionName,
          children: searchHitsForThisSection.map(hit => {
            return { section: foodSectionName, hit: hit }
          })
        };
      } else {
        sectionItem = {
          type: foodSectionName,
          children: [{ section: foodSectionName, hit: searchHitsForThisSection }]
        };
      }
    }

    if (error) {
      sectionItem.error = error;
    }

    if (sectionIndex >= 0) {
      this.searchHitsCache[sectionIndex] = sectionItem;
    } else {
      this.searchHitsCache.push(sectionItem);
    }

    if (foodSectionName === SECTION_TYPE.ElasticsearchUserHistory) {
      this.userHistorySearchComplete = true;
    }
    if (this.userHistorySearchComplete) { // Only set the dropdown results once user history search completes
      let newState = {
        searchHits: _.cloneDeep(this.searchHitsCache) // FUTURE: Must cloneDeep otherwise this breaks lots of things. Figure out why later.
      };
      this.setState(newState);
    }
  }

  setNewTopAutofillParams(ddItem, topServingIndex, topServingNumber) {
    this.topDDItem = _.cloneDeep(ddItem);
    this.topServingIndex = topServingIndex;
    this.topServingNumber = topServingNumber;
  }

  onFoodSuggestionsClear() { // Don't clear searchHits! Need to cache it for when we change servings and stuff too.
    this.isDropdownOpenCache = false;
    this.setState({
      isDropdownOpen: this.isDropdownOpenCache,
      selectedServingSourceUrl: '' // Mitigation for Asana #571382166857758
    });
  }

  renderFoodSuggestion(selectedItem) { // How each suggestion is rendered in the dropdown.
    if (selectedItem.error) {
      return (<small><i>{selectedItem.error}</i></small>);
    }
    let selectedHit = selectedItem.hit;
    
    let brandName = _.get(selectedHit._source, `brandName`, null);
    let brandNameElement = brandName ? (<span style={{ color: 'navy' }}>[{brandName}]</span>) : (<span />);

    let privateToUsersList = _.get(selectedHit._source, `privateTo`, []);
    let isPrivateToUser = (privateToUsersList.length > 0 && _.includes(privateToUsersList, this.props.userId));
    let userFirstName = this.props.userStatus.name.split(' ')[0];

    let foodSuggestionElement = isPrivateToUser ?
      (<small>
        <span style={{ color: 'darkorange' }}>
          [Private to {userFirstName}]
        </span>
        &nbsp;
        <b>{brandNameElement} {selectedHit._source.name}</b>
      </small>) : (<small><b>{brandNameElement} {selectedHit._source.name}</b></small>);

    let servingsText = '';
    let servings = _.get(selectedHit._source, 'servings', []);
    let servingsCount = servings.length;
    for (let i = 0; i < servingsCount; i++) {
      let serving = servings[i];
      let servingName = serving ? getServingName(serving) : '';
      let calories = _.get(serving, 'nutritionData.calories', '?');
      servingsText += i === (servingsCount - 1) ? `${servingName} = ${calories} kcal` : `${servingName} = ${calories} kcal | `;
      if (servingsText.length > MAX_PREVIEW_SERVINGS_CHARS) {
        servingsText += ' ...';
        break;
      }
    }
    let sourceUrl = servingsCount ? _.get(servings[0], 'source.url', '') : ''; // Assume only 1. FUTURE: Account for possibility of more?
    let sourceLink = sourceUrl ? (<small><u><a target='_blank' href={this.state.selectedServingSourceUrl}>Open site in new tab</a></u></small>) : (<span />);

    let userLoggedDataText = '';
    if (!fromExternalSource(selectedHit._id)) {
      const timesLogged = selectedHit._source.timesLogged ? selectedHit._source.timesLogged : '?';

      let lastLogged = [];
      if (selectedHit._source.lastLoggedDates.length >= 1) {
        lastLogged = selectedHit._source.lastLoggedDates.slice(Math.max(selectedHit._source.lastLoggedDates.length - 10, 0));
        _.reverse(lastLogged);
        if (selectedHit._source.lastLoggedDates.length > 10) {
          lastLogged.push('...');
          lastLogged.push(selectedHit._source.lastLoggedDates[0]);
        }
      }
      
      userLoggedDataText = `Logged ${timesLogged} times | Logged on: ${lastLogged.length >= 1 ? lastLogged.join(', ') : '?'}`;
    }

    let deleteButton = this.isFromElasticsearch(selectedItem.section) ?
      (
        <input type="submit" className='btn-danger' value="x" name={selectedHit._id} onClick={this.deleteFood}
          style={{ float: 'right', border: '0', padding: '0px 5px', cursor: 'pointer', fontSize: 'small' }} />
      ) : (<span />)

    let backgroundColor = (selectedHit._id === _.get(this.parsedFood, 'hitId')) ? 'lavender' : 'auto';
    return (
      <div>
        <div style={{ backgroundColor: backgroundColor }}>
          {foodSuggestionElement} {sourceLink}
          {deleteButton}
          <div><small style={{ color: 'darkblue' }}>{servingsText}</small></div>
        </div>
        <div><small style={{ color: 'gray' }}><i>{userLoggedDataText}</i></small></div>
        <hr style={{ margin: '0' }} />
      </div>
    );
  }

  deleteFood(e) {
    e.preventDefault();
    let foodId = e.target.name;
    esUserFoodHistory.deleteFood(foodId);
  }

  foodInputChange(event, { newValue }) {
    if (newValue != undefined) {
      this.setState({
        selectedFoodName: newValue
      });
    }

    // if (_.isEmpty(newValue)) {
    //   this.setState({
    //     addCalorieBuffer: true
    //   });
    // }
  }

  onServingSuggestionsClear() { // Don't clear selectedHitServings. May need cache for later.
  }

  renderServingSuggestion(selectedServing) { // How each suggestion is rendered in the dropdown.
    const selectedServingName = getServingName(selectedServing);
    return (
      <div>
        {selectedServingName}
        <input type="submit" className='btn-danger' value="x" name={selectedServingName} onClick={(e) => this.deleteServing(e, selectedServingName)}
          style={{ float: 'right', border: '0', padding: '0px 5px', cursor: 'pointer', fontSize: 'small' }} />
        <hr style={{ margin: '0' }} />
      </div>
    );
  }

  deleteServing(e, servingName) {
    e.preventDefault();
    if (!servingName) {
      this.setState({
        errorMessage: `Cannot delete empty serving. Did you select anything?`
      });
      return;
    }

    this.deletedHitServings.push(servingName);
    if (this.state.selectedHitServings.length === 1) {
      this.setState({
        errorMessage: `Cannot delete '${servingName}' this since it's the only serving left for this food. You should delete the entire food instead.`
      });
    } else {
      let newServings = esUserFoodHistory.deleteServing(this.state.selectedFoodId, this.state.selectedHitServings, servingName);
      this.setState({
        selectedHitServings: newServings
      });
    }
  }


  servingInputChange(event, { newValue }) {
    if (newValue != undefined) {
      this.setState({
        selectedServingName: newValue
      });
    }
  }

  populateFoodLoggingForm(hit, sectionType, autoPopulateWithTopResult, hitUserIndex) {
    let docBody = hit._source;
    let tags = _.cloneDeep(this.getTagsForFoodHit(hit));
    //let ignoreCalorieBuffer = (!_.isEmpty(tags) && ignoreCalorieBufferForTag(tags)) || !(fromExternalSource(hit._id));
    let brandName = hit._source.brandName ? hit._source.brandName : '';
    this.containsBrandName = !_.isEmpty(brandName);
    this.foodInputChangedSinceLastSelection = false;
    this.caloriesChangedSinceLastSelection = false;

    let newState = {
      selectedFoodId: hit._id,
      selectedSection: sectionType,
      selectedFoodName: docBody.name != undefined ? docBody.name : "",
      brandName: brandName, // Brand name is tracked as meta-data but no longer visibly shown to data entry people. They should include the brand name in the food name going foward (post vHIST).
      autofilled: autoPopulateWithTopResult,
      //addCalorieBuffer: !ignoreCalorieBuffer && !this.containsBrandName,
      ingredients: docBody.ingredients ? docBody.ingredients : [],
      totalServings: docBody.totalServings ? docBody.totalServings : null,
      urls: docBody.urls ? docBody.urls : []
    };
    this.category = docBody.category;

    this.tagsChange(tags);
    let userIndex = hitUserIndex >= 0 ? hitUserIndex : this.getUserIndex(hit);
    let defaultServingDesc;
    let defaultServingNo = 1;
    if (Elasticsearch.indexIsValid(userIndex)) {
      let user = _.get(docBody, `users[${userIndex}]`);
      if (user) { // This can be undefined for private foods that got deleted for this user. Not sure why. FUTURE: figure out
        defaultServingDesc = user.defaultServingDescription; // Can be undefined
        defaultServingNo = Elasticsearch.isValidServingNumber(user.defaultServingNumber) ? user.defaultServingNumber : 1;
      }
    }

    let servingObjects = _.cloneDeep(_.get(docBody, `servings`)); // Do a clone just in case.
    let selectedServingIndex = defaultServingDesc ?
      _.findIndex(servingObjects, item => getServingName(item) === defaultServingDesc) : (autoPopulateWithTopResult ? -1 : 0);

    let servingNumber = Elasticsearch.DEFAULT_SERVING_NUMBER;
    if (autoPopulateWithTopResult) {
      let servingName = null;
      selectedServingIndex = this.topServingIndex;
      let selectedServingIndexValid = Elasticsearch.indexIsValid(selectedServingIndex);
      newState.servingDDPlaceholder = selectedServingIndexValid ? DEFAULT_SERVING_PLACEHOLDER :
        (this.parsedFood.servingName ? `I can't find a match for '${this.parsedFood.servingName}'! Please select.` : `I don't know what the serving is! Please select.`);

      if (Elasticsearch.indexIsValid(selectedServingIndex)) {
        let servingMatch = servingObjects[selectedServingIndex];
        servingName = getServingName(servingMatch);
        servingNumber = this.topServingNumber ? this.topServingNumber : '';
        this.updateObjWithNutritionData(newState, docBody, selectedServingIndex);
      }
      this.updateObjWithServing(newState, servingObjects, selectedServingIndex, servingNumber, defaultServingDesc, defaultServingNo, false);
      newState.foodDDPlaceholder = DEFAULT_FOOD_PLACEHOLDER; // Reset placeholder text since we're no longer looking for autofill top result.
      this.mappedFood.servingName = servingName; // For analytics, see Analytics.js
      this.mappedFood.brandName = hit._source.brandName;
    } else {
      this.updateObjWithServing(newState, servingObjects, selectedServingIndex, servingNumber, defaultServingDesc, defaultServingNo, true);
      this.updateObjWithNutritionData(newState, docBody, selectedServingIndex);
    }

    if (servingNumber != Elasticsearch.DEFAULT_SERVING_NUMBER) {
      newState.selectedFoodNutritionData = this.updateNutritionDataWithNewServingNo(servingNumber, newState, autoPopulateWithTopResult);
    }
    let unitServingObj = this.computeFQUnitServing(tags, newState.servingNumber, newState.selectedServingName, _.get(newState, 'selectedFoodNutritionData.calories'));
    newState.numberOfUnitServings = unitServingObj.numberOfUnitServings;
    newState.fqHabitMatches = unitServingObj.fqHabitMatches;

    if (_.get(newState, 'selectedFoodNutritionData.calories', 0) > 1000) {
      newState.warningMessage = `THAT'S A LOT OF CALORIES (${newState.selectedFoodNutritionData.calories} cal)! Are you sure this user ate ${newState.servingNumber} x ${newState.selectedServingName}?`;
    } else {
      newState.warningMessage = '';
    }
    this.setState(newState); // Putting this outside of this if-else block dismisses the dropdown FUTURE: figure out why
  }

  selectedFoodNutritionDataChange(e) {
    let name = e.target.name;
    let nutritionData = _.cloneDeep(this.state.selectedFoodNutritionData);
    nutritionData[name] = e.target.value;
    this.setState({ selectedFoodNutritionData: nutritionData });

    if (name === 'calories') {
      this.setNewCalorieBufferValue(nutritionData.calories);
      this.caloriesChangedSinceLastSelection = true;
      this._clearIngredientsIfNameOrCaloriesChanged();
    }
  }

  _clearIngredientsIfNameOrCaloriesChanged = () => {
    if (this.caloriesChangedSinceLastSelection && this.foodInputChangedSinceLastSelection) {
      this.setState({
        ingredients: []
      });
    }
  }

  setNewCalorieBufferValue(calories) { // Assuming this.state.calorieBufferPercent is up to date
    let newCalorieBufferValue = getPercentOf(this.state.calorieBufferPercent, calories);
    this.setState({
      calorieBufferValue: newCalorieBufferValue
    });
  }

  selectedServingChange(selection) { // When dropdown selection changes. Return value is passed to foodInputChange.
    let newState = {};
    if (selection === undefined) {
      this.updateObjWithServing(newState, [], -1, Elasticsearch.DEFAULT_SERVING_NUMBER, '', 1, true); // Reset serving info
      // Leave nutrition data as it is
    } else if (_.isEmpty(this.state.selectedFoodId)) {
      this.setState({
        errorMessage: "There was a problem retrieving servings info for this food. Did you change the food name after selecting it from dropdown?"
      })
    } else {
      if (_.includes(this.deletedHitServings, selection.name)) {
        return; // This seving was just deleted. FYI clicking the 'x' button on the suggestion will invoke this function.
      }
      let index = _.findIndex(this.state.selectedHitServings, item => getServingName(item) === getServingName(selection));
      let hit = this.getHit(this.state.selectedFoodId);
      this.updateObjWithServing(newState, this.state.selectedHitServings, index, Elasticsearch.DEFAULT_SERVING_NUMBER,
        this.defaultServingDesc, this.defaultServingNo, true);
      let docBody = hit._source;
      this.updateObjWithNutritionData(newState, docBody, index);
    }
    let unitServingObj = this.computeFQUnitServing(this.state.tags, newState.servingNumber, newState.selectedServingName, _.get(newState, 'selectedFoodNutritionData.calories'));
    newState.numberOfUnitServings = unitServingObj.numberOfUnitServings;
    newState.fqHabitMatches = unitServingObj.fqHabitMatches;

    if (_.get(newState, 'selectedFoodNutritionData.calories', 0) > 1000) {
      newState.warningMessage = `THAT'S A LOT OF CALORIES (${newState.selectedFoodNutritionData.calories} cal)! Are you sure this user ate ${newState.servingNumber} x ${selection.name}?`;
    } else {
      newState.warningMessage = '';
    }
    this.setState(newState);
    return (selection === undefined) ? '' : getServingName(selection);
  }

  selectedServingTextChange({ value, reason }) {
    if (reason === 'input-changed' || reason === 'input-focused' || reason === 'suggestions-revealed') {
      let newState = {
        selectedServingName: value
      };

      if (reason === 'input-changed') {
        // Reset this to 1. Otherwise we accidentally add new serving description with old servingNumber,
        // causing wrong nutritionData values to be stored by the time it reaches index.
        newState.servingNumber = Elasticsearch.DEFAULT_SERVING_NUMBER;
        newState.servingNumberInputText = 1;
        newState.selectedServingIndex = -1;
      }

      this.setState(newState);

      if (reason === 'input-changed') {
        this.useDataEntryValCache = false;
      }
    }
  }

  shouldRenderSuggestions() {
    return true;
  }

  servingNumberChange(e) {
    let newServingInput = e.target.value; // It can be the empty string.
    let newState = { servingNumberInputText: newServingInput };
    let servingNumber = parseFloat(newServingInput);
    let isValidServingNumber = Elasticsearch.isValidServingNumber(servingNumber);
    if (isValidServingNumber) {
      newState.servingNumber = servingNumber;
    }

    if (newServingInput && isValidServingNumber) { // If an existing hit is selected, compute new nutrition data based on default serving.
      newState.selectedFoodNutritionData = this.updateNutritionDataWithNewServingNo(servingNumber, this.state, false);
    }
    let unitServingObj = this.computeFQUnitServing(this.state.tags, servingNumber, this.state.selectedServingName, _.get(newState, 'selectedFoodNutritionData.calories'));
    newState.numberOfUnitServings = unitServingObj.numberOfUnitServings;
    newState.fqHabitMatches = unitServingObj.fqHabitMatches;

    if (_.get(newState, 'selectedFoodNutritionData.calories', 0) > 1000) {
      newState.warningMessage = `THAT'S A LOT OF CALORIES (${newState.selectedFoodNutritionData.calories} cal)! Are you sure this user ate ${servingNumber} x ${this.state.selectedServingName}?`;
    } else {
      newState.warningMessage = '';
    }
    this.setState(newState);
  }

  updateNutritionDataWithNewServingNo(servingNumber, currentState, autoPopulateWithTopResult) {

    let multiplier;
    let existingNutritionData;
    let newNutritonData = {};
    let usedDefaults = false;

    if (autoPopulateWithTopResult) {
      let serving = currentState.selectedHitServings[currentState.selectedServingIndex];
      if (serving) {
        multiplier = servingNumber;
        existingNutritionData = _.cloneDeep(serving.nutritionData);
        usedDefaults = true;
      }
    }

    if (!usedDefaults) { // Possible that there aren't any servings if this is a new food entry. Compute new nutrition data based on what's already in teh fields.
      newNutritonData = _.cloneDeep(currentState.selectedFoodNutritionData);
      multiplier = servingNumber / currentState.servingNumber;
      existingNutritionData = _.cloneDeep(currentState.selectedFoodNutritionData);
    }

    let nutritionDataNames = Object.keys(NUTRITION_DATA_NAMES);
    for (let n = 0; n < nutritionDataNames.length; n++) {
      let nutritionDataName = nutritionDataNames[n];
      let nutritionDataValue = existingNutritionData[nutritionDataName];
      if (nutritionDataValue != null || nutritionDataValue != undefined) {
        let newVal = _.round(nutritionDataValue * multiplier, 2);
        newNutritonData[nutritionDataName] = newVal;
        if (nutritionDataName === 'calories') {
          this.setNewCalorieBufferValue(newVal);
        }
      } else {
        newNutritonData[nutritionDataName] = null;
      }
    }
    return newNutritonData;
  }

  updateObjWithServing(obj, servingObjects, index, servingNo,
    /*defaultServing* are user-specific elasticsearch-persisted settings*/ defaultServingDesc, defaultServingNo, includeSourceUrl
  ) {
    if (Elasticsearch.indexIsValid(index)) {
      console.assert(servingObjects[index], `servingObjects is ${JSON.stringify(servingObjects)} and index is ${index}`);
      let servingName = getServingName(servingObjects[index]);
      obj.selectedServingName = servingName;
      obj.selectedServingIndex = index;

      // Only check 'make serving default' box if the selected serving is actually the specified default.
      // Otherwise, admin must manually check that box if they want to specify a new default serving for this user.
      let makeServingDefault = (servingName === defaultServingDesc);
      this.defaultServingDesc = defaultServingDesc; // Cache for later
      this.defaultServingNo = defaultServingNo;
      obj.servingNumber = makeServingDefault ? this.defaultServingNo : servingNo;
      obj.servingNumberInputText = obj.servingNumber;
      obj.makeServingDefault = makeServingDefault;

      let sourceUrl = _.get(servingObjects[index], 'source.url', '');
      obj.selectedServingSourceUrl = includeSourceUrl ? sourceUrl : ''; // Setting this will bring up an iframe that navigates to sourceUrl.
    } else { // Reset everything
      obj.selectedServingName = '';
      obj.selectedServingIndex = -1;
      obj.servingNumber = servingNo;
      obj.servingNumberInputText = obj.servingNumber;
      obj.makeServingDefault = false;
      obj.selectedServingSourceUrl = '';
    }

    obj.selectedHitServings = _.cloneDeep(servingObjects);
  }

  updateObjWithNutritionData(obj, docBody, servingIndex) {
    if (!Elasticsearch.indexIsValid(servingIndex)) {
      return;
    }

    let nutritionData = _.get(docBody, `servings[${servingIndex}].nutritionData`);
    obj.selectedFoodNutritionData = _.cloneDeep(nutritionData);

    this.setNewCalorieBufferValue(nutritionData.calories);
  }

  checkboxChanged(event) {
    let target = event.target;
    let value = target.checked;
    let name = target.name;
    this.setState({
      [name]: value
    });
  }

  isFromElasticsearch(sectionName) {
    return sectionName === SECTION_TYPE.ElasticsearchUserHistory;
  }

  isFromExternalSource(sectionName) {
    return sectionName === SECTION_TYPE.External || sectionName === SECTION_TYPE.ExternalRecipes;
  }

  wasFromExternalSource(foodId) {
    if (!foodId) {
      return false;
    }

    let hit = this.getHit(foodId);
    let foodSource = this.getFoodSource(hit._source, this.state.selectedServingName);
    return foodSource != null && foodSource != undefined && foodSource != {};
  }

  async uploadFoodsSubmitAsync(e) {
    if (e) { e.preventDefault(); }
    this._validateAndSubmitFoods(false);
  }

  _validateAndSubmitFoods = async (ignoreMergeConflicts) => {
    if (!ignoreMergeConflicts) {
      const mergeConflictExists = await this._checkIfMergeConflictExists();
      if (mergeConflictExists) {
        this._togglePromptOverwriteFood(true);
        Analytics.logDEMergeConflict(this.props.userId, this.props.adminId, 'Pending');
        return;
      }
    }

    let newState = { errorMessage: '', bottomErrorMessage: '' };
    if (this.props.foodTagRequired && (!this.state.tags || !this.state.tags.length)) {
      newState.bottomErrorMessage += `Must select at least one food tag.\n`;
    }

    if (!this.state.selectedServingName) {
      newState.errorMessage += `Serving description is required.\n`;
    }

    if (!Elasticsearch.isValidServingNumber(this.state.servingNumber)) {
      newState.errorMessage += `Serving number must be a number greater than 0!\n`;
    }

    if (!_.isEmpty(this.state.fqHabitMatches) && (this.state.numberOfUnitServings === null || this.state.numberOfUnitServings === '' || this.state.numberOfUnitServings === undefined)) {
      newState.bottomErrorMessage += `Unit serving box (below) must have a value!\n`;
    }

    let nutritionData = _.cloneDeep(this.state.selectedFoodNutritionData);
    this.updateWithNetCarbs(nutritionData);
    NUTRITION_DATA.forEach(dataName => {
      if (nutritionData[dataName] === null || nutritionData[dataName] === '' || _.toNumber(nutritionData[dataName]) === NaN) {
        if (dataName !== 'netCarbs') { // Skip net carbs because it'll already be included with carbs and fiber messages.
          if (dataName === 'sugar' || dataName === 'fiber') { 
            nutritionData[dataName] = 0;
          } else {
            newState.bottomErrorMessage += `${dataName} is required.\n`;
          }
        }
      }
    });

    if (this.caloriesChangedSinceLastSelection && !(newState.errorMessage || newState.bottomErrorMessage) && !(this.state.tags && this.state.tags.includes(FOOD_TAGS.BeverageCaloricAlcohol))) {
      // All nutrition data exists. Now do sanity check on macros. Omit this check if this.caloriesChangedSinceLastSelection === true, since user might have
      // previously logged a food wtih ### calories but no macros. Don't want to block DEP on this if they relog it again from history.
      let calories = _.toNumber(nutritionData['calories']);
      let carbs = _.toNumber(nutritionData['carbs']);
      let protein = _.toNumber(nutritionData['protein']);
      let fat = _.toNumber(nutritionData['fat']);

      let caloriesByMacros = carbs * 4 + protein * 4 + fat * 9;
      let caloriesAndMacrosDiff = calories - caloriesByMacros;
      if (Math.abs(caloriesAndMacrosDiff / calories) >= .5 && Math.abs(caloriesAndMacrosDiff) >= 5) {
        // Now try with net carbs instead of carbs since some companies don't include calories from fiber on their labels.
        const fiber = _.toNumber(nutritionData['fiber']);
        caloriesByMacros = (carbs - fiber) * 4 + protein * 4 + fat * 9;
        caloriesAndMacrosDiff = calories - caloriesByMacros;
        if (Math.abs(caloriesAndMacrosDiff / calories) >= .5 && Math.abs(caloriesAndMacrosDiff) >= 5) {
          newState.bottomErrorMessage += "Macros don't total up to Calories. Are you sure the macros are correct?\n";
        }
      }
    }

    if (newState.errorMessage || newState.bottomErrorMessage) {
      this.submittedForThisDataEntryObj = false;
      this.setState(newState);
      return;
    } //Don't process any more until errors get resolved.

    this.returnFoodToCaller(this.state.selectedFoodId, nutritionData);

    this.parsedFood = {};
    this.mappedFood = {};
    this.containsBrandName = false;
    this.originalText = '';
    newState.originalText = this.originalText;
    if (newState.errorMessage) {
      this.submittedForThisDataEntryObj = false;
    } else {
      this.submittedForThisDataEntryObj = true;
    }
    this.setState(newState);
  }

  _togglePromptOverwriteFood = (show) => {
    this.setState({
      promptOverwriteFood: show
    })
  }

  _buildPromptOverwriteFoodPopup = () => {
    return (
      <span style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
        <div style={{
          width: '550px',
          height: '400px',
          borderWidth: '4px',
          borderColor: 'red',
          border: 'solid',
          position: 'absolute',
          backgroundColor: 'gold',
          right: '50%',
          bottom: '50%',
          zIndex: '100',
          padding: '10px'
        }}
        >
          <div>WARNING: "{this.state.selectedFoodName}" already exists in this user's history and you're about to overwrite it with different calories than before. Are you sure this is what you want to do? Note: If user logged a brand name with their food, you should also include brand name with the food.</div>
          <button style={{ margin: '10px' }} onClick={
            () => {
              Analytics.logDEMergeConflict(this.props.userId, this.props.adminId, 'Overwrite');
              this._validateAndSubmitFoods(true);
              this._togglePromptOverwriteFood(false);
            }
          }>
            Overwrite existing food
          </button>
          <button style={{ margin: '10px' }} onClick={
            () => {
              Analytics.logDEMergeConflict(this.props.userId, this.props.adminId, 'Cancel');
              this._togglePromptOverwriteFood(false);
            }
          }>
            ↩️ Go back, rename food
          </button>
          {
            this.props.togglePromptHeedsHelp ?
              <button style={{ margin: '10px' }} onClick={
                () => {
                  Analytics.logDEMergeConflict(this.props.userId, this.props.adminId, 'NeedsHelp');
                  this._togglePromptOverwriteFood(false);
                  this.props.togglePromptHeedsHelp(true);
                }
              }>
                Get help
              </button> : <span />
          }
        </div>
      </span>
    );
  }

  _checkIfMergeConflictExists = async () => {
    // let { servingUnit, servingUnitNumber } = Elasticsearch.parseServingDescription(this.state.selectedServingName);
    // let existingFoodMatch = await esUserFoodHistory.getFoodByNameAndServing(this.props.userId, this.state.selectedFoodName, servingUnit);
    // if (existingFoodMatch.error) {
    //   // Server would have already logged this error. We don't need to do anything here.
    // } else if (existingFoodMatch) {
    //   let existingServings = existingFoodMatch._source.servings;
    //   let servingMatchIndex = this._findHitServingIndex(servingUnit, existingServings);
    //   if (servingMatchIndex >= 0) {
    //     let existingCalories = existingServings[servingMatchIndex].nutritionData.calories;
    //     let newCalories =
    //       getNumber(this.state.selectedFoodNutritionData.calories) / (getNumber(this.state.servingNumber) * getNumber(servingUnitNumber));
    //     if (Math.abs(existingCalories - newCalories) >= 50) {
    //       return true;
    //     }
    //   }
    // }
    return false;
  }

  _findHitServingIndex = (servingName, servings) => {
    return servingName ? _.findIndex(servings, item => getServingName(item) === this._formatName(servingName)) : -1;
  }

  _formatName = (text) => {
    return text.toLowerCase().trim();
  }


  updateWithNetCarbs(nutritionData) {
    let fiber = nutritionData['fiber'] ? _.toNumber(nutritionData['fiber']) : 0;
    let carbs = nutritionData['carbs'] ? _.toNumber(nutritionData['carbs']) : 0;
    nutritionData['netCarbs'] = carbs > fiber ? carbs - fiber : 0;
  }

  getFoodSource(docBody, servingName) {
    let selectedServingIndex = this._findHitServingIndex(servingName, docBody.servings);
    if (selectedServingIndex >= 0) {
      return _.get(docBody, `servings[${selectedServingIndex}]source`);
    }
    return null;
  }

  getUserIndex(hit) { // NOTE: This must match function by the same name in vivabot:foodTextHandler.js
    let userIndex = -1;
    let innerHitIndex = 0; // FUTURE: There should only be 1, but maybe later we will support more?
    if (_.has(hit, `inner_hits.users.hits.hits[${innerHitIndex}]._nested.offset`)) {
      userIndex = hit.inner_hits.users.hits.hits[innerHitIndex]._nested.offset;
    }
    return userIndex;
  }

  getDayFromDateString(dateString) {
    let dateSplit = dateString.split('-');
    let loggedDate = new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2]);
    return loggedDate.getDay();
  }

  async returnFoodToCaller(foodId, nutritionData) {
    if (this.props.userId && this.state.selectedFoodName) {
      let foodFormEntry = this._getFoodFormEntryObject(foodId, nutritionData);
      this.props.onSubmit(foodFormEntry);
      this.setState({ autofilled: false });
    } else {
      this.setState({ errorMessage: "user id and food name required!" });
    }
  }

  _getFoodFormEntryObject = (foodId, nutritionData) => {
    let consolidatedServingName = this._getConsolidatedServingText(
      this.state.servingNumber, this.state.selectedServingName, this.state.selectedFoodName);

    let foodFormEntry = {
      foodId: foodId ? foodId : '',
      name: this.state.selectedFoodName,
      brandName: this.state.brandName,
      serving: this.state.selectedServingName,
      servingNumber: this.state.servingNumber,
      consolidatedServingName: consolidatedServingName,
      foodGroups: this.state.tags,
      targetDate: this.state.targetDate,
      // Do empty checks so none of these end up being undefined. This causes crashes when trying to write to firestore later.
      ingredients: this.state.ingredients ? this.state.ingredients : [],
      urls: this.state.urls ? this.state.urls : [],
      category: this.category ? this.category : null,
      totalServings: this.state.totalServings ? this.state.totalServings : null,
    };

    let nutritionDataNames = Object.keys(NUTRITION_DATA_NAMES);
    for (let n = 0; n < nutritionDataNames.length; n++) {
      let nutritionDataName = nutritionDataNames[n];
      let nutritionDataValue = _.toNumber(nutritionData[nutritionDataName]);
      if (nutritionDataName === 'calories' && this.state.addCalorieBuffer && this.state.calorieBufferValue && nutritionDataValue) {
        nutritionDataValue = nutritionDataValue + this.state.calorieBufferValue;
      }
      foodFormEntry[nutritionDataName] = nutritionDataValue >= 0 ? nutritionDataValue : null;
    }

    return foodFormEntry;
  }

  calorieBufferChange(e) {
    let newCalorieBufferPercent = e.target.value;
    let newCalorieBufferValue = getPercentOf(newCalorieBufferPercent, this.state.selectedFoodNutritionData.calories);
    this.setState({
      calorieBufferPercent: newCalorieBufferPercent,
      calorieBufferValue: newCalorieBufferValue
    });
    Database.updateBufferValue(this.props.userId, 'calories', newCalorieBufferPercent);
  }

  storeInputReference(autosuggest) {
    if (autosuggest !== null) {
      this.input = autosuggest.input;
    }
  };

  tagsChange(tags) {
    // let ignoreCalorieBuffer = ignoreCalorieBufferForTag(tags);
    // let addCalorieBuffer = this.state.addCalorieBuffer;
    // if (ignoreCalorieBuffer) {
    //   addCalorieBuffer = false;
    // }

    let unitServingObj = this.computeFQUnitServing(tags, this.state.servingNumber, this.state.selectedServingName);
    this.setState({
      tags: tags,
      // addCalorieBuffer: addCalorieBuffer,
      numberOfUnitServings: unitServingObj.numberOfUnitServings,
      fqHabitMatches: unitServingObj.fqHabitMatches
    });
  }

  computeFQUnitServing(tags, parsedServingNo, servingName, calories) {
    let servingNumber = isNaN(parsedServingNo) ? Elasticsearch.DEFAULT_SERVING_NUMBER : parsedServingNo;
    if (_.isEmpty(tags) || _.isEmpty(servingName)) {
      return { numberOfUnitServings: 1, fqHabitMatches: [] };
    }

    if (!_.isEmpty(this.usersCannedFoodHabits) && !_.isEmpty(this.usersCannedFoodHabitsTagsIndex)) {
      let fqHabitMatches = getFoodQualityMatches(tags, this.usersCannedFoodHabitsTagsIndex);
      fqHabitMatches = _.isEmpty(fqHabitMatches) ? null :
        fqHabitMatches.map(id => {
          if (!_.isEmpty(this.dailyHabitsMap) && this.dailyHabitsMap[id]) {
            return this.dailyHabitsMap[id];
          } else if (!_.isEmpty(this.weeklyHabitsMap) && this.weeklyHabitsMap[id]) {
            return this.weeklyHabitsMap[id]
          }
        });

      servingName = servingName.replace(/\s*\(.*?\)\s*/g, ''); // Remove anything that's in parenthesis. Mitigation for things like Asana #881662982128546
      let { servingUnit, servingUnitNumber } = Elasticsearch.parseServingDescription(servingName);
      let numberOfUnitServings = getNumberOfUnitServings(servingNumber, servingUnitNumber, servingUnit, tags);
      return { numberOfUnitServings: numberOfUnitServings, fqHabitMatches: fqHabitMatches };
    }

    return { numberOfUnitServings: 1, fqHabitMatches: [] };
  }

  toggleConverterTool() {
    this.setState({ showConversionTool: !this.state.showConversionTool });
  }

  onComputeServingNumber(result) {
    this.servingNumberChange({ target: { value: result } });
  }

  numberOfUnitServingsChange(e) {
    this.setState({ numberOfUnitServings: _.toNumber(e.target.value) });
  }

  render() {
    const foodInputProps = {
      placeholder: this.state.foodDDPlaceholder,
      value: this.state.selectedFoodName ? this.state.selectedFoodName : '',
      onChange: this.foodInputChange,
      className: 'food-input'
    };

    let foodDDTheme = this.state.selectedFoodName ? AutosuggestTheme : AutosuggestThemeRed;
    foodDDTheme.suggestionsList.maxHeight = '250px';
    let userFoodHistoryDropdown = (
      <Autosuggest
        theme={this.state.selectedFoodName ? AutosuggestTheme : AutosuggestThemeRed}
        multiSection={true}
        suggestions={this.state.searchHits}
        onSuggestionsFetchRequested={this.selectedFoodNameTextChangeAsync}
        onSuggestionsClearRequested={this.onFoodSuggestionsClear}
        getSuggestionValue={this.selectedFoodNameChange.bind(this)}
        //onSuggestionHighlighted={this.foodHighlighted}
        renderSuggestion={this.renderFoodSuggestion}
        renderSectionTitle={this.renderSectionTitle}
        getSectionSuggestions={this.getSectionSuggestions}
        inputProps={foodInputProps}
        ref={this.storeInputReference}
      />
    );

    let servingInputBoxValue = '';
    if (this.state.selectedServingName) {
      servingInputBoxValue = this.state.selectedServingName;
    }

    const servingInputProps = {
      placeholder: this.state.servingDDPlaceholder,
      value: servingInputBoxValue,
      onChange: this.servingInputChange
    };

    let selectedHitServingsDD = (
      <Autosuggest
        theme={this.state.selectedServingName ? AutosuggestTheme : AutosuggestThemeRed}
        suggestions={this.state.selectedHitServings}
        onSuggestionsFetchRequested={this.selectedServingTextChange.bind(this)}
        onSuggestionsClearRequested={this.onServingSuggestionsClear}
        getSuggestionValue={this.selectedServingChange}
        renderSuggestion={this.renderServingSuggestion}
        inputProps={servingInputProps}
        shouldRenderSuggestions={this.shouldRenderSuggestions.bind(this)}
      />
    );

    let calorieBufferExtension = this.state.addCalorieBuffer ?
      (<b style={{ color: 'red' }}>
        {this.state.calorieBufferValue >= 0 ? `+${this.state.calorieBufferValue}` : this.state.calorieBufferValue}
      </b>) : (<span />);

    let originalText = this.state.originalText ? ( // This should be the text that the user actually typed like '1 handful of greens'
      <div className='row' style={{ margin: '0', textAlign: 'center', backgroundColor: 'aqua' }}>
        Original text:&nbsp;<b>{this.state.originalText}</b>
      </div>
    ) : (<span />);

    let calorieBufferOption =
      <div className='row' style={{ margin: '0px 5px 10px' }}>
        <input style={{ margin: '5px 0px' }} type='checkbox' name='addCalorieBuffer' checked={this.state.addCalorieBuffer} onChange={this.checkboxChanged} />
        &nbsp;Check this if user is eating restaurant food without providing nutrition info (adds <input style={{ margin: '0px 5px', height: '20px', width: '30px' }} value={this.state.addCalorieBuffer ? this.state.calorieBufferPercent : ''}
          min='-100' max='100' onChange={this.calorieBufferChange} type='number' />% buffer kcal).
      </div>;

    let numberOfUnitServingsField = !_.isEmpty(this.state.fqHabitMatches) ? (
      <div style={{ margin: '5px', padding: '5px', backgroundColor: 'azure' }}>
        {this.state.servingNumber} x {this.state.selectedServingName} is
        &nbsp;
        <input style={{ width: '50px', borderColor: this.state.numberOfUnitServings === null || this.state.numberOfUnitServings === '' ? 'red' : 'auto' }} type='number'
          value={this.state.numberOfUnitServings != null ? this.state.numberOfUnitServings : ''} onChange={this.numberOfUnitServingsChange.bind(this)}></input>
        &nbsp;
        of a typical serving unit of {this.state.selectedFoodName}. Counts towards habits:
        <div><b style={{ color: 'purple' }}>• {this.state.fqHabitMatches.join(' • ')}</b></div>
      </div>
    ) : (<span />);

    let backgroundColor = this.state.autofilled ? 'yellow' : 'white';
    const foodTagsForm = this.props.foodTagRequired ?
      <FoodTagsForm required={true} tags={this.state.tags} tagsChange={this.tagsChange.bind(this)} /> : <span/>;

    return (
      <div>
        <div style={{
          backgroundColor: backgroundColor, border: this.state.autofilled ? '1px solid' : 'auto',
          borderColor: this.state.autofilled ? 'red' : 'auto', padding: '10px'
        }}>
          {/*selectedExternalFoodPreview*/}
          <div style={{ color: "red" }}>{this.state.errorMessage}</div>
          <div style={{ color: "green" }}>{this.state.successMessage}</div>
          {originalText}
          <div className='row' style={{ margin: '0' }}>
            <div className='col-8' style={{ margin: '0', padding: '0' }}>{userFoodHistoryDropdown}</div>
            <div className='col-1'>
              <button onClick={this.props.onClose}>
                Dismiss
              </button>
            </div>
            <a href="https://platform.fatsecret.com">
                <img alt="Nutrition information provided by fatsecret Platform API" src="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_horizontal_white.png" srcset="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_horizontal_white@2x.png 2x, https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_horizontal_white@3x.png 3x" border="0"/>
            </a>
          </div>

          <div style={{ backgroundColor: this.state.warningMessage ? 'red' : backgroundColor }}>
            <div className='row' style={{ marginTop: '5px' }}>
              <div style={{ margin: '5px', color: 'white' }}>{this.state.warningMessage ? this.state.warningMessage : ''}</div>
              <div className='col-2' style={{ display: 'inline-block', padding: '0', margin: '0px', marginRight: '5px', width: '50px' }} />
            </div>
            <div className='row' style={{ margin: '0' }}>
              <div className='col-1' style={{ padding: '0px' }}>
                <input style={{ backgroundColor: 'white', padding: '1px' }} type='submit' value='⚖️' onClick={this.toggleConverterTool.bind(this)} />
              </div>
              <input className='col-2' style={{ display: 'inline-block', padding: '0', margin: '0px', width: '50px', height: '20px' }}
                type='number' step=".01" placeholder="1.0" value={this.state.servingNumberInputText} onChange={this.servingNumberChange}>
              </input>
              <div className='col-8' style={{ display: 'inline-block', padding: '0' }}>
                {selectedHitServingsDD}
              </div>
            </div>
            {this.state.showConversionTool ? (<div className='row'><FoodConversionTool onCompute={this.onComputeServingNumber.bind(this)} /></div>) : (<span />)}
          </div>

          <div style={{ marginTop: '5px', marginBottom: '0px', color: '#9B59B6' }}><b><small>Leave fields empty if you can't find the value. <u>DON'T</u> enter 0 unless it is actually 0.</small></b></div>
          <div className='row'>
            <span style={{ margin: '0px 5px' }}>
              <div>Calories</div>
              <div>
                <input type="number" style={{ width: '70px', height: '20px', marginBottom: '5px', borderWidth: '1.5px', borderColor: 'red' }}
                  name={NUTRITION_DATA_NAMES.calories}
                  value={this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.calories]}
                  onChange={this.selectedFoodNutritionDataChange} /> {calorieBufferExtension}
              </div>
            </span>
            <span style={{ margin: '0px 5px' }}>
              <div>Fat</div>
              <div>
                <input type="number" style={{ width: '50px', height: '20px', marginBottom: '5px', borderWidth: '1.5px', borderColor: 'red' }}
                  name={NUTRITION_DATA_NAMES.fat}
                  value={this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.fat] === undefined || this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.fat] === null ? '' : this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.fat]}
                  onChange={this.selectedFoodNutritionDataChange} />
              </div>
            </span>
            <span style={{ margin: '0px 5px' }}>
              <div>Carbs</div>
              <div>
                <input type="number" style={{
                  width: '50px', height: '20px', marginBottom: 5, borderWidth: '1.5px',
                  borderColor: 'red'
                }}
                  name={NUTRITION_DATA_NAMES.carbs}
                  value={this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.carbs] === undefined || this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.carbs] === null ? '' : this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.carbs]}
                  onChange={this.selectedFoodNutritionDataChange} />
              </div>
            </span>
            <span style={{ margin: '0px 5px' }}>
              <div>Protein</div>
              <div>
                <input type="number" style={{ width: '50px', height: '20px', marginBottom: '5px', borderWidth: '1.5px', borderColor: 'red' }}
                  name={NUTRITION_DATA_NAMES.protein}
                  value={this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.protein] === undefined || this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.protein] === null ? '' : this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.protein]}
                  onChange={this.selectedFoodNutritionDataChange} />
              </div>
            </span>
            <span style={{ margin: '0px 5px' }}>
              <div>Fiber</div>
              <div>
                <input type="number" style={{
                  width: '50px', height: '20px', marginBottom: '5px', borderWidth: '1.5px'
                }}
                  name={NUTRITION_DATA_NAMES.fiber}
                  value={this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.fiber] === undefined || this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.fiber] === null ? '' : this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.fiber]}
                  onChange={this.selectedFoodNutritionDataChange} />
              </div>
            </span>

            <span style={{ margin: '0px 5px' }}>
              <div>Sugar</div>
              <div>
                <input type="number" style={{
                  width: '50px', height: '20px', marginBottom: '5px', borderWidth: '1.5px'
                }}
                  name={NUTRITION_DATA_NAMES.sugar}
                  value={this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.sugar] === undefined || this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.sugar] === null ? '' : this.state.selectedFoodNutritionData[NUTRITION_DATA_NAMES.sugar]}
                  onChange={this.selectedFoodNutritionDataChange} />
              </div>
            </span>

          </div>
          {calorieBufferOption}
          <div style={{ color: "red" }}>{this.state.bottomErrorMessage}</div>
          {this.state.promptOverwriteFood ? this._buildPromptOverwriteFoodPopup() : <span />}
          <div style={{ padding: '5px', backgroundColor: _.isEmpty(this.state.fqHabitMatches) ? 'auto' : '#00ffff' }}>
            {foodTagsForm} {numberOfUnitServingsField}
            <input type="submit" onClick={this.uploadFoodsSubmitAsync} value="Confirm" style={{ marginRight: '5px', height: '25px' }} />
          </div>
          {
            this.state.urls && this.state.urls.length > 0 ?
              <div style={{ textAlign: 'right', color: 'gray' }}>
                <div><u>Url</u></div>
                <div>
                  {this.state.urls[0]}
                </div>
              </div> : <span />
          }
          {
            this.state.ingredients && this.state.ingredients.length > 0 ?
              <div style={{ textAlign: 'right', color: 'gray' }}>
                <div>
                  <u>
                    Ingredients {this.state.totalServings ? <span>(Makes {this.state.totalServings} servings)</span> : <span />}
                  </u>
                </div>
                {
                  this.state.ingredients.map(
                    ingredient => {
                      return <div>
                        {ingredient.name} ({ingredient.servingDescription})
                        {/* {
                          ingredient.notes ?
                            <div>
                              - {ingredient.notes}
                            </div> : <div />
                        } */}
                      </div>
                    }
                  )
                }
                {
                  this.props.updateRecipe ?
                    <button onClick={() => this.props.updateRecipe(this.state.selectedFoodName, this.state.ingredients, this.state.totalServings)}>
                      Edit Ingredients
                    </button> : <span />
                }
              </div> : <span />
          }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/FoodLoggingForm2.js